import React from 'react';
import * as S from './styles';
import { Props } from './interfaces';

export const Link: React.FC<Props> = ({ children, href }) => {
  return <S.Link href={href}>{children}</S.Link>;
};
